export default {
  methods: {
    routeScrollBack(fromName, targetName, $scroller) {
      if (targetName.includes(fromName) && localStorage.orginScrollTop) {
        const isBody = $scroller.is("html, body");
        const timer = setInterval(() => {
          const hasScrollBar = isBody
            ? $scroller.height() > window.$(window).height()
            : $scroller.get(0).scrollHeight > $scroller.height();
          if (hasScrollBar) {
            $scroller.animate(
              { scrollTop: localStorage.orginScrollTop },
              400,
              "linear"
            );
            clearInterval(timer);
          }
        }, 300);
      }
    },
    routeScrollSave(toName, targetName, $scroller) {
      if (targetName.includes(toName)) {
        localStorage.orginScrollTop = $scroller.scrollTop();
      }
    },
    componentScrollBack($scroll) {
      if (this.$parent.orginScrollTop) {
        $scroll.scrollTop(this.$parent.orginScrollTop);
      }
    },
    componentScrollSave($scroll) {
      this.$parent.orginScrollTop = $scroll.scrollTop();
    }
  }
};
